import { render, staticRenderFns } from "./score_edit.vue?vue&type=template&id=6a2ef5ee&scoped=true&"
import script from "./score_edit.vue?vue&type=script&lang=js&"
export * from "./score_edit.vue?vue&type=script&lang=js&"
import style0 from "./score_edit.vue?vue&type=style&index=0&id=6a2ef5ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ef5ee",
  null
  
)

export default component.exports